import { z } from 'zod';
/** The system emails an admin can override the subject/body of — Admin ▸
 * Email & notifications' template list (design/orion-crm-design/
 * rendered-html/AdminEmail.html). Each key's default (used until overridden)
 * lives next to the code that actually sends it, not here — this catalogue
 * only names what's editable and what placeholder tokens its body supports. */
export const EMAIL_TEMPLATE_KEYS = [
    'lead_created_admin',
    'password_reset',
    'invite_user',
    'task_reminder',
    'lead_assigned',
    'team_member_added',
    'team_member_removed',
    'ai_qualification_purged',
];
export const EMAIL_TEMPLATE_META = {
    lead_created_admin: { label: 'New lead created (admin alert)', placeholders: ['{{recipientName}}', '{{leadName}}', '{{companyName}}', '{{sourceName}}', '{{creatorName}}', '{{leadUrl}}'] },
    password_reset: { label: 'Password reset', placeholders: ['{{recipientName}}', '{{resetUrl}}', '{{expiryHours}}'] },
    invite_user: { label: 'Invite user', placeholders: ['{{recipientName}}', '{{inviteUrl}}', '{{inviterName}}', '{{tenantName}}'] },
    task_reminder: { label: 'Task reminder', placeholders: ['{{recipientName}}', '{{taskTitle}}', '{{dueAt}}'] },
    lead_assigned: { label: 'Lead assigned', placeholders: ['{{recipientName}}', '{{leadName}}', '{{assignerName}}', '{{leadUrl}}'] },
    team_member_added: { label: 'Added to a team', placeholders: ['{{recipientName}}', '{{teamName}}', '{{actorName}}'] },
    team_member_removed: { label: 'Removed from a team', placeholders: ['{{recipientName}}', '{{teamName}}', '{{actorName}}'] },
    ai_qualification_purged: {
        label: 'AI qualification records auto-deleted',
        placeholders: ['{{recipientName}}', '{{totalCount}}', '{{summary}}', '{{retentionDays}}'],
    },
};
export const updateEmailTemplateSchema = z.object({
    subject: z.string().trim().min(1).max(200),
    bodyHtml: z.string().trim().min(1).max(20_000),
});
export const emailTemplateResponseSchema = z.object({
    key: z.enum(EMAIL_TEMPLATE_KEYS),
    label: z.string(),
    isCustom: z.boolean(),
    subject: z.string(),
    bodyHtml: z.string(),
    placeholders: z.array(z.string()),
    updatedByName: z.string().nullable(),
    updatedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=email-templates.js.map